import React, { useState } from "react";
import SFBadge from "../badge";
import { useTranslation } from "react-i18next";
import useStyled from "../../hooks/useStyled";
import { SFFilterListIcon } from "../icons";
import SFCollapseMenu from "../collapseMenu";
import { SFStack } from "../grid";
import SFSearchField from "../textField/search";
import DataGridFilters from "./dataGridFilters";
import { useSelector } from "react-redux";

const { styled } = useStyled();

const StyledStack = styled(SFStack)(({ theme }) => ({
  height: "50px",
  width: "100%",
}));

const dataGridSearch = (props) => {
  const gridFilters = useSelector(
    (state) =>
      state.gridLayout.find((x) => x.gridName === props.gridName)?.state?.filter
        ?.filterModel[props.selectedFilterColumn]?.values
  );
  const filters = gridFilters ?? [];
  const [filtersOpen, setFiltersOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <StyledStack alignItems="center">
      <SFCollapseMenu
        header={
          <SFSearchField
            variant="outlined"
            size="small"
            placeholder={
              props.searchLabel ?? t("components.datagrid.searchLabel")
            }
            onChange={props.onChange}
            hasClearBtn
          />
        }
        expandIcon={
          props.selectedFilterColumn ? (
            <SFBadge badgeContent={filters.length} color="info">
              <SFFilterListIcon />
            </SFBadge>
          ) : null
        }
        onExpand={() => {
          if (!filtersOpen) setFiltersOpen(true);
        }}
      >
        {props.selectedFilterColumn && filtersOpen && (
          <DataGridFilters
            filters={filters}
            initializeFilter={props.initializeFilter}
            handleFilterChange={props.handleFilterChange}
            filterLabel={props.filterLabel}
          />
        )}
      </SFCollapseMenu>
    </StyledStack>
  );
};

export default dataGridSearch;
